import { create } from 'zustand';
import api from '../services/api';

const authStore = create((set) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true,

  register: async ({ firstName, lastName, practiceName, email, password, role = 'practitioner' }) => {
    const { data } = await api.post('/api/v1/auth/register', { firstName, lastName, practiceName, email, password, role });
    const { user, accessToken } = data.data;
    localStorage.setItem('accessToken', accessToken);
    set({ user, isAuthenticated: true });
  },

  login: async (email, password) => {
    const { data } = await api.post('/api/v1/auth/login', { email, password });
    if (data.requireTotp) {
      // Return mfaToken so Login page can handle the TOTP challenge step
      return { requireTotp: true, mfaToken: data.mfaToken };
    }
    const { user, accessToken } = data.data;
    localStorage.setItem('accessToken', accessToken);
    set({ user, isAuthenticated: true });
  },

  totpVerify: async (mfaToken, code) => {
    const { data } = await api.post('/api/v1/auth/totp-verify', { mfaToken, code });
    const { user, accessToken } = data.data;
    localStorage.setItem('accessToken', accessToken);
    set({ user, isAuthenticated: true });
  },

  logout: async () => {
    try {
      await api.post('/api/v1/auth/logout');
    } catch {
      // ignore — clear client state regardless
    }
    localStorage.removeItem('accessToken');
    set({ user: null, isAuthenticated: false });
  },

  loadUser: async () => {
    const token = localStorage.getItem('accessToken');
    if (!token) {
      set({ isLoading: false });
      return;
    }
    try {
      const { data } = await api.get('/api/v1/auth/me');
      set({ user: data.data.user, isAuthenticated: true, isLoading: false });
    } catch {
      localStorage.removeItem('accessToken');
      set({ user: null, isAuthenticated: false, isLoading: false });
    }
  },
}));

export default authStore;
